import { Tooltip } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { MdRefresh } from 'react-icons/md'

import { cx } from '@/Ship/Helpers/cssClass'
import listStyles from '@/Ship/Templates/CrudResource/CrudResourceTemplate.module.css'

import styles from './RefreshButton.module.css'

/** Мінімум, скільки крутиться іконка (один повний оберт): швидкий запит інакше майже непомітний */
const MIN_SPIN_MS = 900

interface RefreshButtonProps {
    onRefresh: () => void
    /** Запит іде: іконка крутиться, повторний клік ігнорується */
    refreshing: boolean
    /** Підпис у підказці й для скрінрідера */
    label?: string
}

/**
 * Кнопка «Оновити» шапки картки: квадрат 36×36 у стилі кнопок фільтра й налаштувань,
 * підказка, іконка крутиться під час запиту. Одна на звіти, головну й журнал ERP.
 *
 * Не disabled під час запиту: antd 6 не обгортає disabled-кнопку, і підказка зависала б
 * (mouseleave не приходить); повторний клік просто ігнорується.
 */
export const RefreshButton = ({ onRefresh, refreshing, label = 'Оновити дані' }: RefreshButtonProps) => {
    // Запит часто триває 50–150 мс, а оберт — 0,9 с: без мінімуму анімації майже не видно
    const [minSpin, setMinSpin] = useState(false)
    const timerRef = useRef<number | undefined>(undefined)
    // Таймер не чистимо при завершенні запиту (інакше minSpin лишився б true), лише при розмонтуванні
    useEffect(() => () => window.clearTimeout(timerRef.current), [])
    useEffect(() => {
        if (!refreshing) return
        setMinSpin(true)
        window.clearTimeout(timerRef.current)
        timerRef.current = window.setTimeout(() => setMinSpin(false), MIN_SPIN_MS)
    }, [refreshing])
    const spinning = refreshing || minSpin

    return (
        <Tooltip title={label}>
            <button
                type="button"
                className={`${cx(listStyles, 'iconButton')} ${spinning ? cx(styles, 'spinning') : ''}`}
                aria-label={label}
                aria-busy={refreshing}
                onClick={() => {
                    if (!refreshing) onRefresh()
                }}
            >
                <MdRefresh />
            </button>
        </Tooltip>
    )
}
